import React, { createContext, useContext, useState, useCallback } from 'react';
import { XIcon, CheckIcon, AlertIcon, InfoIcon } from './Icons';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(null);

  const showNotification = useCallback((message, type = 'info') => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, message, type }]);
    
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 5000);
  }, []);

  const showConfirm = useCallback((message, onConfirm, onCancel) => {
    return new Promise((resolve) => {
      setConfirmDialog({
        message,
        onConfirm: () => {
          setConfirmDialog(null);
          if (onConfirm) onConfirm();
          resolve(true);
        },
        onCancel: () => {
          setConfirmDialog(null);
          if (onCancel) onCancel();
          resolve(false);
        }
      });
    });
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  const getNotificationIcon = (type) => {
    switch(type) {
      case 'success': return <CheckIcon size={18} />;
      case 'error': return <XIcon size={18} />;
      case 'warning': return <AlertIcon size={18} />;
      case 'info': return <InfoIcon size={18} />;
      default: return <InfoIcon size={18} />;
    }
  };

  return (
    <NotificationContext.Provider value={{ showNotification, showConfirm }}>
      {children}
      
      {/* Notifications toast */}
      <div className="notification-container">
        {notifications.map(notif => (
          <div key={notif.id} className={`notification notification-${notif.type}`}>
            <div className="notification-icon">
              {getNotificationIcon(notif.type)}
            </div>
            <span className="notification-message">{notif.message}</span>
            <button 
              className="notification-close" 
              onClick={() => removeNotification(notif.id)}
            >
              <XIcon size={16} />
            </button>
          </div>
        ))}
      </div>

      {/* Confirm Dialog */}
      {confirmDialog && (
        <>
          <div className="modal-overlay" onClick={confirmDialog.onCancel}></div>
          <div className="confirm-dialog">
            <div className="confirm-dialog-content">
              <p>{confirmDialog.message}</p>
              <div className="confirm-dialog-actions">
                <button 
                  className="btn btn-secondary" 
                  onClick={confirmDialog.onCancel}
                >
                  Annuler
                </button>
                <button 
                  className="btn btn-danger" 
                  onClick={confirmDialog.onConfirm}
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </NotificationContext.Provider>
  );
};
